import React, { Component } from "react";
import PropTypes from "prop-types";
import addDays from "date-fns/add_days";
import subDays from "date-fns/sub_days";
import endOfDay from "date-fns/end_of_day";
import DatePicker from "./date-picker";

export default class DateInterval extends Component {
  static propTypes = {
    className: PropTypes.string,
    dateFormat: PropTypes.string,
    disabled: PropTypes.bool,
    disableWeekends: PropTypes.bool,
    filterDate: PropTypes.func,
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    minDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
    maxRange: PropTypes.number,
    onChangeStart: PropTypes.func,
    onChangeEnd: PropTypes.func,
    openToDate: PropTypes.instanceOf(Date)
  };

  getMin = () =>
    this.props.maxRange && this.props.endDate
      ? subDays(this.props.endDate, this.props.maxRange)
      : undefined;

  getMax = () =>
    this.props.maxRange && this.props.startDate
      ? addDays(this.props.startDate, this.props.maxRange)
      : undefined;

  render = () => {
    let min = this.getMin();
    let max = this.getMax();
    let minDate =
      this.props.minDate && this.props.minDate > min ? this.props.minDate : min;
    let maxDate =
      this.props.maxDate && this.props.maxDate < max ? this.props.maxDate : max;
    return (
      <div>
        <DatePicker
          isClearable={true}
          dateFormat={this.props.dateFormat}
          disabled={this.props.disabled}
          disableWeekends={this.props.disableWeekends}
          filterDate={this.props.filterDate}
          selected={this.props.startDate}
          selectsStart={true}
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          minDate={minDate}
          maxDate={this.props.endDate || this.props.maxDate}
          onChange={this.props.onChangeStart}
          placeholderText="Date from"
        />
        <DatePicker
          isClearable={true}
          dateFormat={this.props.dateFormat}
          disabled={this.props.disabled}
          disableWeekends={this.props.disableWeekends}
          filterDate={this.props.filterDate}
          selected={this.props.endDate}
          selectsEnd={true}
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          minDate={this.props.startDate || this.props.minDate}
          maxDate={maxDate}
          onChange={val => this.props.onChangeEnd(val ? endOfDay(val) : val)}
          placeholderText="Date to"
        />
      </div>
    );
  };
}
